import React from 'react';

export default function Register() {
  return (
    <>
    {/* Begin page */}
    <div className="accountbg" />
    <div className="wrapper-page">
      <div className="card">
        <div className="card-body">
          <div className="text-center">
            <a href="index.html" className="logo logo-admin">
              <img src="  images/e-logo.png" height={20} alt="logo" />
            </a>
          </div>
          <div className="p-3">
            <form className="form-horizontal" action="index.html">
              <div className="form-group row">
                <div className="col-12">
                  <input
                    className="form-control"
                    type="email"
                    required=""
                    placeholder="Email"
                  />
                </div>
              </div>
              <div className="form-group row">
                <div className="col-12">
                  <input
                    className="form-control"
                    type="text"
                    required=""
                    placeholder="Username"
                  />
                </div>
              </div>
              <div className="form-group row">
                <div className="col-12">
                  <input
                    className="form-control"
                    type="password"
                    required=""
                    placeholder="Password"
                  />
                </div>
              </div>
              <div className="form-group row">
                <div className="col-12">
                  <div className="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      id="customCheck1"
                    />
                    <label
                      className="custom-control-label font-weight-normal"
                      htmlFor="customCheck1"
                    >
                      I accept{" "}
                      <a href="#" className="text-muted">
                        Terms and Conditions
                      </a>
                    </label>
                  </div>
                </div>
              </div>
              <div className="form-group text-center row m-t-20">
                <div className="col-12">
                  <button
                    className="btn btn-danger btn-block waves-effect waves-light"
                    type="submit"
                  >
                    Register
                  </button>
                </div>
              </div>
              <div className="form-group m-t-10 mb-0 row">
                <div className="col-12 m-t-20 text-center">
                  <a href="/login" className="text-muted">
                    Already have account?
                  </a>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    {/* jQuery  */}
    {/* App js */}
  </>
   
  )

}